import { render, staticRenderFns } from "./SelectContact.vue?vue&type=template&id=bc63f130&"
import script from "./SelectContact.vue?vue&type=script&lang=js&"
export * from "./SelectContact.vue?vue&type=script&lang=js&"
import style0 from "./SelectContact.vue?vue&type=style&index=0&id=bc63f130&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports